// Logo tipo televisora — "Televisa Occidente · 6 Canales"
export const NetworkLogo = ({ theme = "dark", compact = false }) => {
  const isDark = theme === "dark";
  const fg = isDark ? "#F7F9F6" : "#2D3436";
  const dotColors = ["#FF8A80", "#A8E6CF", "#81D4FA", "#E8C547", "#FF8A80", "#81D4FA"];

  const Mark = (
    <svg
      viewBox="0 0 64 64"
      className={compact ? "h-7 w-7" : "h-10 w-10"}
      aria-hidden="true"
    >
      {/* ojo tipo televisora */}
      <ellipse cx="32" cy="32" rx="29" ry="19" fill="none" stroke={fg} strokeWidth="3.5" />
      <circle cx="32" cy="32" r="11" fill="#FF8A80" />
      <circle cx="32" cy="32" r="4.5" fill={fg} />
      <circle cx="27" cy="27" r="2" fill="#F7F9F6" />
    </svg>
  );

  if (compact) {
    return (
      <div className="flex items-center gap-2.5" data-testid="network-logo">
        {Mark}
        <div className="leading-none">
          <div
            className="font-display text-sm font-extrabold tracking-tight"
            style={{ color: fg }}
          >
            TELEVISORA DE <span className="text-coral">OCCIDENTE</span>
          </div>
          <div
            className="mt-0.5 font-mono text-[9px] uppercase tracking-[0.25em]"
            style={{ color: fg, opacity: 0.6 }}
          >
            7+ Señales TV 15 canales (Analogos y Digitales)
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center gap-4" data-testid="network-logo">
      {Mark}
      <div className="leading-none">
        <div
          className="font-display text-2xl font-extrabold tracking-tight"
          style={{ color: fg }}
        >
          TELEVISA <span className="text-coral">OCCIDENTE</span>
        </div>
        <div className="mt-1.5 flex items-center gap-2">
          <div className="flex gap-1">
            {dotColors.map((c, i) => (
              <span
                key={i}
                className="h-2 w-2 rounded-full"
                style={{ backgroundColor: c }}
              />
            ))}
          </div>
          <span
            className="font-mono text-[10px] uppercase tracking-[0.3em]"
            style={{ color: fg, opacity: 0.65 }}
          >
            6+ Señales TV
          </span>
        </div>
      </div>
    </div>
  );
};
